import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "Only what I stand behind",
    body: "No filler, no random affiliate spam. Three brands I personally run — vetted for quality, flavor, and consistency before they ever make this page.",
  },
  {
    num: "02",
    title: "The discount is the point",
    body: "Every link carries a live referral code. You save 10% instantly at checkout — no hunting for coupons, no expired codes, no catch.",
  },
  {
    num: "03",
    title: "One tap, straight to the source",
    body: "Each card routes you directly to the official store with the discount pre-attached. Buy from the brand, keep the savings.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative border-t border-white/10 px-6 py-24 md:px-10 md:py-32"
    >
      <div className="mx-auto max-w-7xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-16 font-mono-accent text-xs uppercase tracking-[0.25em] text-zinc-500"
        >
          / The Manifesto
        </motion.p>

        <div className="grid gap-12 md:grid-cols-3 md:gap-16">
          {chapters.map((c, i) => (
            <motion.div
              key={c.num}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <span className="font-mono-accent text-5xl font-bold text-[#ccff00]">
                {c.num}
              </span>
              <h3 className="mt-6 font-display text-2xl font-bold leading-tight tracking-tight text-white md:text-3xl">
                {c.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-zinc-400">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
